"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeStateMachine = void 0;
const ValueObjects_1 = require("../ValueObjects");
const ObserverList_1 = require("./ObserverList");
function makeStateMachine() {
    return new StateMachineImp();
}
exports.makeStateMachine = makeStateMachine;
class StateMachineImp {
    constructor() {
        this.serializedSystems = new Map();
        this.serilizationVersion = 2;
        this.stateAppliedObservers = new ObserverList_1.ObserverList();
        this.transitionEaseFunction = (normalizedTime) => {
            return normalizedTime; // default to a linear function
        };
        this.applySerializedStatesString = (state, duration = 0) => {
            if (state === "") {
                this.setDefaultState(duration);
            }
            else {
                try {
                    const stateObj = JSON.parse(state);
                    this.setSerializedStates(stateObj, duration);
                }
                catch (e) {
                    this.setDefaultState(duration);
                    console.warn("[StateMachine] Failed to deserialize state string: " + e);
                }
            }
        };
        this.registerSerializedSystem = (serializedSystem) => {
            if (this.serializedSystems.has(serializedSystem.name)) {
                const err = new Error(`[StateMachine] Duplicate stateable systems encountered: ${serializedSystem.name}`);
                console.error(err.message);
                return ValueObjects_1.reject(err);
            }
            this.serializedSystems.set(serializedSystem.name, serializedSystem);
            return ValueObjects_1.resolve(null);
        };
        this.getSerializedStates = () => {
            const systems = Array.from(this.serializedSystems.values());
            const serializedStates = systems.map((system) => {
                const state = system.getSystemState();
                return {
                    seriliziationVersion: system.seriliziationVersion,
                    name: system.name,
                    state,
                };
            });
            return {
                version: this.serilizationVersion,
                systems: serializedStates,
            };
        };
        this.setSerializedStates = (state, duration) => {
            if (state.version === 2) {
                const appliedToSystems = [];
                state.systems.forEach((systemState) => {
                    const seriliazableSystem = this.serializedSystems.get(systemState.name);
                    if (seriliazableSystem) {
                        seriliazableSystem.applySystemState(systemState.state, systemState.seriliziationVersion, duration);
                    }
                    else {
                        console.warn("Unable to find seriarializedSystem " + systemState.name);
                    }
                    appliedToSystems.push(systemState.name);
                });
                this.serializedSystems.forEach((system) => {
                    if (!appliedToSystems.includes(system.name)) {
                        system.applyDefaultState(duration);
                    }
                });
                this.stateAppliedObservers.notify();
                return ValueObjects_1.resolve(null);
            }
            // Here is where we will add support for future versions
            else {
                const err = new Error(`[StateMachine] Unsupported sereialized state encountered: ${state.version}`);
                console.error(err.message);
                return ValueObjects_1.reject(err);
            }
        };
        this.setDefaultState = (duration) => {
            this.serializedSystems.forEach((system) => {
                system.applyDefaultState(duration);
            });
            this.stateAppliedObservers.notify();
        };
        this.addStateHasBeenAppliedObserver = (observer) => {
            this.stateAppliedObservers.add(observer);
        };
        this.removeStateHasBeenAppliedObserver = (observer) => {
            this.stateAppliedObservers.remove(observer);
        };
    }
}
